export default function Q_0(props) {
    return (
        <>
            <h5>Question type Not supported</h5>
        </>
    )
}